import { render, staticRenderFns } from "./roleRowComponent.vue?vue&type=template&id=1bc18c30&scoped=true&"
import script from "./roleRowComponent.vue?vue&type=script&lang=js&"
export * from "./roleRowComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc18c30",
  null
  
)

export default component.exports